import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import axios from 'axios';
import { useGlobalContext } from "../../Context/Authentation";
import Lottie from 'react-lottie';
import noNotesanimation from '../../Animations/no notes.json'
import SingleNotes from '../../Components/Notes/SingleNotes';

export default function Home() {

    const { user, refresh, setAllNotesArray, setUpdateModalcontent, setUpdateModalTitle, setNoteId, setDeleteModalTitle, setSearchKeyword } = useGlobalContext();
    const [allNotes, setallNotes] = useState([]);
    const [loading, setloading] = useState(true);

    let PinnedNotes = [];
    localStorage.getItem("pinnedNotes")?.split(",").forEach((e, i) => { PinnedNotes[i] = e })


    const GetAllNotes = async () => {
        setSearchKeyword("")
        try {
            setloading(true);
            const config = { headers: { Authorization: `Bearer ${user?.token}` } }
            const { data } = await axios.get(`https://quick-notes-c09v.onrender.com/api/notes/${user?._id}`, config);
            setallNotes(data);
            setAllNotesArray(data);
            setloading(false);
        } catch (error) {
            console.log(error.message);
            toast.error(error.message, {
                position: "bottom-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
            setloading(false);
        }
    }

    useEffect(() => {
        user?.token && GetAllNotes()
        // eslint-disable-next-line 
    }, [user?.token, refresh])

    const defaultOptions = {
        loop: false,
        autoplay: true,
        animationData: noNotesanimation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    }
    return (
        <>
            {!loading ? (
                <>
                    {allNotes.length !== 0 ? (
                        <div className='layout grid' id='NotesContainer' >
                            {
                                allNotes?.map((e, index) => {
                                    const DeleteclickHndler = () => {
                                        setDeleteModalTitle(e?.title)
                                        setNoteId(e?._id)
                                    }
                                    const UpdateclickHndler = () => {
                                        setUpdateModalTitle(e?.title)
                                        setUpdateModalcontent(e?.content)
                                        setNoteId(e?._id)
                                    }
                                    return (
                                        <div className='notewrapper' key={index} style={{ order: "1", }}>
                                            <SingleNotes index={index} event={e} UpdateclickHndler={UpdateclickHndler}
                                                DeleteclickHndler={DeleteclickHndler} id={e._id} PinnedNotes={PinnedNotes} />
                                        </div>)
                                })
                            }
                        </div>
                    ) : (
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                            <Lottie options={defaultOptions}
                                width={"90%"}
                                height={"fit - content"}
                                style={{ marginTop: "auto", width: "400px", opacity: "0.6" }}
                            />
                            <h3>No notes found</h3>
                        </div>)}
                </>
            ) : (
                <div className="text-center" style={{ height: "calc(100vh - 220px)" }}>
                    <div style={{ height: "100%", width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>

                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}
